import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=60872948&"
import script from "./reviewDetail.vue?vue&type=script&lang=js&"
export * from "./reviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./reviewDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports